var _g, _g2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLogoAnimated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 403 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n\t\tWEB_KALYZEE_LOGOTYPE\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M678.581,475.549a31.043,31.043,0,1,0,24.372,24.37A31.072,31.072,0,0,0,678.581,475.549Z",
    transform: "translate(-400.267 -266.67)",
    fill: "#17bf87"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: 0,
    dur: "0.2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1",
    begin: 0.2,
    dur: "0.6s"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-400.267 -266.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M749.556,534.725A3.837,3.837,0,0,0,753,536.867h44.923a3.837,3.837,0,0,0,3.443-5.534L693.788,312.925l-18.94-38.688a3.838,3.838,0,0,0-6.915.043L649.382,313.4,574.215,472.572a3.838,3.838,0,0,1-6.942,0l-32.479-68.885a3.844,3.844,0,0,1,0-3.274l60.281-127.853a3.838,3.838,0,0,0-3.471-5.475H543.06a3.84,3.84,0,0,0-3.472,2.2L481.451,392.591l-3.687,7.82a3.837,3.837,0,0,0,0,3.274l3.687,7.819,58.137,123.307a3.838,3.838,0,0,0,3.472,2.2H595.2a3.813,3.813,0,0,0,3.474-2.239l32.455-69.335c-.053-.025,37.776-80.373,37.776-80.373a3.839,3.839,0,0,1,6.915-.059Z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "scale",
    begin: "0.0s",
    dur: "0.4s",
    from: "0.7 1",
    to: "1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: 0,
    begin: "0s",
    dur: "0.3s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;1",
    begin: "0.3s",
    dur: "0.2s"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 51.584,
    height: 269.783,
    rx: 3.838
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "scale",
    begin: "0s",
    dur: "0.3s",
    from: "1 0",
    to: "1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1",
    dur: "0.4s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogoAnimated);
export default __webpack_public_path__ + "static/media/small-logo-animated.d0fd6d86463f38adebc925a7fa4ba7b4.svg";
export { ForwardRef as ReactComponent };